var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheck = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Next Step") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_SDI_checkStatic"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "checkStatic_Rectangle",
    stroke: "#7B97BC",
    strokeWidth: 6,
    fill: "#FFFFFF",
    x: 3,
    y: 3,
    width: 58,
    height: 58,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8137085,37.9852814 L43.7989899,21 L46.627417,23.8284271 L26.8284271,43.627417 L26.2071068,43.0060967 L26.1923882,43.0208153 L17,33.8284271 L19.8284271,31 L26.8137085,37.9852814 Z",
    id: "checkStatic_Combined-Shape",
    fill: "#4B76B7"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/iconCheck.1c462b1b7a22d6a4f479c1be763fb2db.svg";